import React from 'react'
import { Box, Skeleton, Typography } from '@mui/material'
import { IconSeeker } from '@ui-seeker/core'

import { dsColorNew } from '@palette'


const percent = (current, total) => total ? Math.max(0, Math.min(100, Math.round(current / total * 100))) : 0

function Bar({ value, thick = false }) {
	return <Box role="progressbar" aria-valuenow={value} aria-valuemin={0} aria-valuemax={100} sx={{
		height: thick ? 8 : 5, borderRadius: 4, backgroundColor: dsColorNew.pillTrackBg, overflow: 'hidden',
	}}>
		<Box sx={{ height: 1, width: `${value}%`, borderRadius: 4, backgroundColor: value >= 100 ? dsColorNew.successBar : dsColorNew.appBlue, transition: 'width .4s ease' }}/>
	</Box>
}

// Progress of a run by one dimension (websites or offices): the total on top, one row per item below
export default function AppSearchesProgressCard({ icon, title, current, total, rows = [], isLoading }) {
	const totalValue = percent(current, total)

	return <Box sx={{ border: `1px solid ${dsColorNew.grayBorder}`, borderRadius: '12px', px: 2, py: 1.75, minWidth: 0 }}>
		<Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', mb: 1 }}>
			<Typography component="h3" sx={{ display: 'flex', alignItems: 'center', gap: 1, fontSize: 13, fontWeight: 600, color: dsColorNew.textTitle }}>
				<IconSeeker icon={icon} sx={{ fontSize: 13, color: dsColorNew.appBlue }}/>
				{title}
			</Typography>
			{isLoading
				? <Skeleton width={44} height={30}/>
				: <Typography sx={{ fontSize: 20, fontWeight: 700, color: totalValue >= 100 ? dsColorNew.successText : dsColorNew.textTitle }}>{totalValue}%</Typography>}
		</Box>
		{isLoading ? <Skeleton variant="rounded" height={8}/> : <Bar value={totalValue} thick/>}

		<Box sx={{ mt: 1.75, display: 'flex', flexDirection: 'column', gap: 1.25, maxHeight: '30vh', overflowY: 'auto', pr: 0.5 }}>
			{isLoading
				? [0, 1, 2].map(idx => <Skeleton key={idx} variant="rounded" height={18}/>)
				: rows.map(({ key, label, current: rowCurrent, total: rowTotal }) => {
					const value = percent(rowCurrent, rowTotal)
					return <Box key={key} sx={{ display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) 110px 40px', gap: 1.25, alignItems: 'center' }}>
						<Box sx={{ minWidth: 0, overflow: 'hidden' }}>{label}</Box>
						<Bar value={value}/>
						<Typography sx={{ fontSize: 13, textAlign: 'right', fontVariantNumeric: 'tabular-nums', color: value >= 100 ? dsColorNew.successText : dsColorNew.textMuted, fontWeight: value >= 100 ? 600 : 400 }}>
							{value}%
						</Typography>
					</Box>
				})}
		</Box>
	</Box>
}
